var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 143 121"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cash_svg__a",
    d: "M.67 60.158h86.66V.128H.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cash_svg__c",
    d: "M.67 60.158h86.66V.128H.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cash_svg__e",
    d: "M.67 60.158h86.66V.128H.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cash_svg__g",
    d: "M.67 60.158h86.66V.128H.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cash_svg__i",
    d: "M.67 60.158h86.66V.128H.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cash_svg__k",
    d: "M.67 60.158h86.66V.128H.67z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M57.938 120.077h74.742v-20.3H57.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M57.015 120.077h23.992v-20.3H57.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M57.015 108.082h23.992v-1.846H57.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M81.007 108.082h51.673v-1.846H81.007zM81.007 114.54h51.673v-1.845H81.007z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.423 60.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.97 50.153c0 3.606-2.904 6.53-6.486 6.53-3.583 0-6.487-2.924-6.487-6.53s2.904-6.53 6.487-6.53c3.582 0 6.487 2.924 6.487 6.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M52.424 51.45a.43.43 0 0 0-.16-.334 2 2 0 0 0-.476-.282v1.173q.636-.11.636-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.142.133.46.276V48.1q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.545v.966h-.641v-.947q-1.143-.024-2.004-.406v-1.243q.408.203.982.357a5 5 0 0 0 1.022.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.43-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.439 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.298.613.387.258.567.57.18.31.18.725"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cash_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cash_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M.67 20.138h74.558V.128H.67z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M.67 20.138h23.61V.128H.67z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M.67 7.668h23.612v-1.74H.67zM.67 14.339h23.612v-1.74H.67z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M24.28 7.668h50.947v-1.74H24.281zM24.28 14.339h50.947v-1.74H24.281z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M41.101 20.138H58.41V.128H41.1z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.242 10.133c0 3.606-2.905 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53c3.582 0 6.487 2.923 6.487 6.53",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M50.695 11.43a.43.43 0 0 0-.159-.334 2 2 0 0 0-.477-.283v1.173q.636-.108.636-.555m-1.88-2.86a.45.45 0 0 0 .142.342q.143.134.46.275V8.081q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.544v.966h-.641v-.947q-1.142-.023-2.003-.405v-1.243q.407.202.98.357a5 5 0 0 0 1.023.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.431-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.44 1.103a5 5 0 0 0-1.497-.368v1.39q.914.353 1.298.613.387.257.567.569t.18.726",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M12.772 40.148H87.33v-20.01H12.77z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M12.772 40.148h23.611v-20.01H12.772z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116936",
    d: "M12.771 27.679h23.612v-1.74H12.771zM12.771 34.347h23.612v-1.74H12.771z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M36.384 27.679h50.947v-1.74H36.384zM36.384 34.347h50.947v-1.74H36.384z",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.344 30.143c0 3.606-2.904 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53 6.487 2.924 6.487 6.53",
    mask: "url(#cash_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M62.798 31.44a.43.43 0 0 0-.16-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.637-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.14.134.46.275v-1.107q-.603.09-.603.49m3.29 2.79q0 .749-.539 1.202-.537.456-1.507.544v.966h-.642v-.946q-1.14-.024-2.002-.406v-1.243q.407.202.981.357.573.156 1.021.184v-1.46l-.312-.122q-.927-.368-1.314-.799-.385-.43-.386-1.067 0-.683.532-1.124.531-.44 1.48-.534v-.721h.642v.702q1.071.048 1.938.433l-.44 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.299.613.386.258.567.569t.18.726",
    mask: "url(#cash_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M56.093 120.077h74.741v-20.3H56.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M56.093 120.077h23.99v-20.3h-23.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116936",
    d: "M56.093 108.082h23.99v-1.846h-23.99zM56.093 114.54h23.99v-1.845h-23.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M80.084 108.082h51.673v-1.846H80.084zM80.084 114.54h51.673v-1.845H80.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M96.693 120.077h17.532v-20.3H96.693z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.423 60.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.242 50.153c0 3.606-2.905 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53c3.582 0 6.487 2.924 6.487 6.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M50.695 51.45a.43.43 0 0 0-.159-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.636-.556m-1.88-2.86a.45.45 0 0 0 .142.342q.143.133.46.276V48.1q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.545v.966h-.641v-.947q-1.142-.024-2.003-.406v-1.243q.407.203.98.357a5 5 0 0 0 1.023.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.43-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.44 1.103a5 5 0 0 0-1.497-.368v1.39q.914.353 1.298.613.387.258.567.57.18.31.18.725"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cash_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cash_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M11.043 40.148h74.559v-20.01H11.043z",
    mask: "url(#cash_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M11.043 40.148h23.612v-20.01H11.043z",
    mask: "url(#cash_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M11.042 27.679h23.613v-1.74H11.042zM11.042 34.347h23.613v-1.74H11.042z",
    mask: "url(#cash_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M34.655 27.679h50.947v-1.74H34.655zM34.655 34.347h50.947v-1.74H34.655z",
    mask: "url(#cash_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M51.475 40.148h17.307v-20.01H51.475z",
    mask: "url(#cash_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M66.615 30.143c0 3.606-2.904 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53 6.487 2.924 6.487 6.53",
    mask: "url(#cash_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M61.069 31.44a.43.43 0 0 0-.16-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.637-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.14.134.46.275v-1.107q-.603.09-.603.49m3.29 2.79q0 .749-.539 1.202-.537.456-1.507.544v.966h-.641v-.946q-1.141-.024-2.003-.406v-1.243q.406.202.981.357.573.156 1.022.184v-1.46l-.313-.122q-.926-.368-1.314-.799-.384-.43-.385-1.067 0-.683.531-1.124.532-.44 1.48-.534v-.721h.642v.702q1.071.048 1.938.433l-.44 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.299.613.386.258.567.569t.18.726",
    mask: "url(#cash_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M29.09 59.978h74.742v-20.3H29.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M28.168 59.978h23.99v-20.3h-23.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M28.168 47.982h23.99v-1.845h-23.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M52.159 47.982h51.673v-1.845H52.16zM52.159 54.442h51.673v-1.846H52.16z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.576)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.97 50.153c0 3.606-2.904 6.53-6.486 6.53-3.583 0-6.487-2.924-6.487-6.53s2.904-6.53 6.487-6.53c3.582 0 6.487 2.924 6.487 6.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M52.424 51.45a.43.43 0 0 0-.16-.334 2 2 0 0 0-.476-.282v1.173q.636-.11.636-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.142.133.46.276V48.1q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.545v.966h-.641v-.947q-1.143-.024-2.004-.406v-1.243q.408.203.982.357a5 5 0 0 0 1.022.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.43-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.439 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.298.613.387.258.567.57.18.31.18.725"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cash_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cash_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M.67 20.138h74.558V.128H.67z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M.67 20.138h23.61V.128H.67z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M.67 7.668h23.612v-1.74H.67zM.67 14.339h23.612v-1.74H.67z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M24.28 7.668h50.947v-1.74H24.281zM24.28 14.339h50.947v-1.74H24.281z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M41.101 20.138H58.41V.128H41.1z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.242 10.133c0 3.606-2.905 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53c3.582 0 6.487 2.923 6.487 6.53",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M50.695 11.43a.43.43 0 0 0-.159-.334 2 2 0 0 0-.477-.283v1.173q.636-.108.636-.555m-1.88-2.86a.45.45 0 0 0 .142.342q.143.134.46.275V8.081q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.544v.966h-.641v-.947q-1.142-.023-2.003-.405v-1.243q.407.202.98.357a5 5 0 0 0 1.023.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.431-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.44 1.103a5 5 0 0 0-1.497-.368v1.39q.914.353 1.298.613.387.257.567.569t.18.726",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M12.772 40.148H87.33v-20.01H12.77z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M12.772 40.148h23.611v-20.01H12.772z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116936",
    d: "M12.771 27.679h23.612v-1.74H12.771zM12.771 34.347h23.612v-1.74H12.771z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M36.384 27.679h50.947v-1.74H36.384zM36.384 34.347h50.947v-1.74H36.384z",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.344 30.143c0 3.606-2.904 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53 6.487 2.924 6.487 6.53",
    mask: "url(#cash_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M62.798 31.44a.43.43 0 0 0-.16-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.637-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.14.134.46.275v-1.107q-.603.09-.603.49m3.29 2.79q0 .749-.539 1.202-.537.456-1.507.544v.966h-.642v-.946q-1.14-.024-2.002-.406v-1.243q.407.202.981.357.573.156 1.021.184v-1.46l-.312-.122q-.927-.368-1.314-.799-.385-.43-.386-1.067 0-.683.532-1.124.531-.44 1.48-.534v-.721h.642v.702q1.071.048 1.938.433l-.44 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.299.613.386.258.567.569t.18.726",
    mask: "url(#cash_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M27.245 59.978h74.742v-20.3H27.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M27.245 59.978h23.991v-20.3H27.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116936",
    d: "M27.245 47.982h23.991v-1.845H27.245zM27.245 54.442h23.991v-1.846H27.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M51.236 47.982h51.673v-1.845H51.236zM51.236 54.442h51.673v-1.846H51.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M67.845 59.978h17.532v-20.3H67.845z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.576)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.242 50.153c0 3.606-2.905 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53c3.582 0 6.487 2.924 6.487 6.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M50.695 51.45a.43.43 0 0 0-.159-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.636-.556m-1.88-2.86a.45.45 0 0 0 .142.342q.143.133.46.276V48.1q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.545v.966h-.641v-.947q-1.142-.024-2.003-.406v-1.243q.407.203.98.357a5 5 0 0 0 1.023.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.43-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.44 1.103a5 5 0 0 0-1.497-.368v1.39q.914.353 1.298.613.387.258.567.57.18.31.18.725"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cash_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cash_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M11.043 40.148h74.559v-20.01H11.043z",
    mask: "url(#cash_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M11.043 40.148h23.612v-20.01H11.043z",
    mask: "url(#cash_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M11.042 27.679h23.613v-1.74H11.042zM11.042 34.347h23.613v-1.74H11.042z",
    mask: "url(#cash_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M34.655 27.679h50.947v-1.74H34.655zM34.655 34.347h50.947v-1.74H34.655z",
    mask: "url(#cash_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M51.475 40.148h17.307v-20.01H51.475z",
    mask: "url(#cash_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M66.615 30.143c0 3.606-2.904 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53 6.487 2.924 6.487 6.53",
    mask: "url(#cash_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M61.069 31.44a.43.43 0 0 0-.16-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.637-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.14.134.46.275v-1.107q-.603.09-.603.49m3.29 2.79q0 .749-.539 1.202-.537.456-1.507.544v.966h-.641v-.946q-1.141-.024-2.003-.406v-1.243q.406.202.981.357.573.156 1.022.184v-1.46l-.313-.122q-.926-.368-1.314-.799-.384-.43-.385-1.067 0-.683.531-1.124.532-.44 1.48-.534v-.721h.642v.702q1.071.048 1.938.433l-.44 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.299.613.386.258.567.569t.18.726",
    mask: "url(#cash_svg__h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M2.647 120.077h74.742v-20.3H2.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M1.724 120.077h23.991v-20.3H1.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M1.724 108.082h23.991v-1.846H1.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M25.715 108.082H77.39v-1.846H25.715zM25.715 114.54H77.39v-1.845H25.715z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.132 60.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.97 50.153c0 3.606-2.904 6.53-6.486 6.53-3.583 0-6.487-2.924-6.487-6.53s2.904-6.53 6.487-6.53c3.582 0 6.487 2.924 6.487 6.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M52.424 51.45a.43.43 0 0 0-.16-.334 2 2 0 0 0-.476-.282v1.173q.636-.11.636-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.142.133.46.276V48.1q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.545v.966h-.641v-.947q-1.143-.024-2.004-.406v-1.243q.408.203.982.357a5 5 0 0 0 1.022.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.43-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.439 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.298.613.387.258.567.57.18.31.18.725"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cash_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cash_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M.67 20.138h74.558V.128H.67z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M.67 20.138h23.61V.128H.67z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M.67 7.668h23.612v-1.74H.67zM.67 14.339h23.612v-1.74H.67z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M24.28 7.668h50.947v-1.74H24.281zM24.28 14.339h50.947v-1.74H24.281z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M41.101 20.138H58.41V.128H41.1z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.242 10.133c0 3.606-2.905 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53c3.582 0 6.487 2.923 6.487 6.53",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M50.695 11.43a.43.43 0 0 0-.159-.334 2 2 0 0 0-.477-.283v1.173q.636-.108.636-.555m-1.88-2.86a.45.45 0 0 0 .142.342q.143.134.46.275V8.081q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.544v.966h-.641v-.947q-1.142-.023-2.003-.405v-1.243q.407.202.98.357a5 5 0 0 0 1.023.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.431-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.44 1.103a5 5 0 0 0-1.497-.368v1.39q.914.353 1.298.613.387.257.567.569t.18.726",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M12.772 40.148H87.33v-20.01H12.77z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M12.772 40.148h23.611v-20.01H12.772z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116936",
    d: "M12.771 27.679h23.612v-1.74H12.771zM12.771 34.347h23.612v-1.74H12.771z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M36.384 27.679h50.947v-1.74H36.384zM36.384 34.347h50.947v-1.74H36.384z",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.344 30.143c0 3.606-2.904 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53 6.487 2.924 6.487 6.53",
    mask: "url(#cash_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M62.798 31.44a.43.43 0 0 0-.16-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.637-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.14.134.46.275v-1.107q-.603.09-.603.49m3.29 2.79q0 .749-.539 1.202-.537.456-1.507.544v.966h-.642v-.946q-1.14-.024-2.002-.406v-1.243q.407.202.981.357.573.156 1.021.184v-1.46l-.312-.122q-.927-.368-1.314-.799-.385-.43-.386-1.067 0-.683.532-1.124.531-.44 1.48-.534v-.721h.642v.702q1.071.048 1.938.433l-.44 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.299.613.386.258.567.569t.18.726",
    mask: "url(#cash_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M.801 120.077h74.742v-20.3H.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M.801 120.077h23.991v-20.3H.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116936",
    d: "M.801 108.082h23.991v-1.846H.802zM.801 114.54h23.991v-1.845H.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M24.792 108.082h51.674v-1.846H24.792zM24.792 114.54h51.674v-1.845H24.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M41.402 120.077h17.532v-20.3H41.402z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.132 60.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.242 50.153c0 3.606-2.905 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53c3.582 0 6.487 2.924 6.487 6.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M50.695 51.45a.43.43 0 0 0-.159-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.636-.556m-1.88-2.86a.45.45 0 0 0 .142.342q.143.133.46.276V48.1q-.603.09-.603.49m3.29 2.79q0 .749-.538 1.202-.538.456-1.507.545v.966h-.641v-.947q-1.142-.024-2.003-.406v-1.243q.407.203.98.357a5 5 0 0 0 1.023.184v-1.46l-.314-.122q-.925-.368-1.314-.799-.383-.43-.384-1.067 0-.683.53-1.124.532-.44 1.482-.534v-.721h.64v.702a5.3 5.3 0 0 1 1.938.433l-.44 1.103a5 5 0 0 0-1.497-.368v1.39q.914.353 1.298.613.387.258.567.57.18.31.18.725"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cash_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cash_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA861",
    d: "M11.043 40.148h74.559v-20.01H11.043z",
    mask: "url(#cash_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M11.043 40.148h23.612v-20.01H11.043z",
    mask: "url(#cash_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6732",
    d: "M11.042 27.679h23.613v-1.74H11.042zM11.042 34.347h23.613v-1.74H11.042z",
    mask: "url(#cash_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F874A",
    d: "M34.655 27.679h50.947v-1.74H34.655zM34.655 34.347h50.947v-1.74H34.655z",
    mask: "url(#cash_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M51.475 40.148h17.307v-20.01H51.475z",
    mask: "url(#cash_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M66.615 30.143c0 3.606-2.904 6.53-6.487 6.53s-6.487-2.924-6.487-6.53 2.904-6.53 6.487-6.53 6.487 2.924 6.487 6.53",
    mask: "url(#cash_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D874A",
    d: "M61.069 31.44a.43.43 0 0 0-.16-.334 2 2 0 0 0-.477-.282v1.173q.636-.11.637-.556m-1.881-2.86a.45.45 0 0 0 .143.342q.14.134.46.275v-1.107q-.603.09-.603.49m3.29 2.79q0 .749-.539 1.202-.537.456-1.507.544v.966h-.641v-.946q-1.141-.024-2.003-.406v-1.243q.406.202.981.357.573.156 1.022.184v-1.46l-.313-.122q-.926-.368-1.314-.799-.384-.43-.385-1.067 0-.683.531-1.124.532-.44 1.48-.534v-.721h.642v.702q1.071.048 1.938.433l-.44 1.103a5 5 0 0 0-1.498-.368v1.39q.913.353 1.299.613.386.258.567.569t.18.726",
    mask: "url(#cash_svg__l)"
  })))));
};
export default SvgCash;